import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';
 
import { Observable } from 'rxjs';
import { Project, ProjectDTO } from '../objects/Project'; // Import your data model
import { environment } from '../environments/environment';
import { AuthService } from '../components/services/auth.service';

@Injectable({
  providedIn: 'root'
}) 
export class ProjectService {
  private apiUrl = environment.apiUrl +'Projects';// Replace with your API endpoint

  constructor(private http: HttpClient,private authService: AuthService) { }

  // getProjects(): Observable<Project[]> {
  //   return this.http.get<Project[]>(this.apiUrl);
  // }


  getProjects(): Observable<Project[]> {

    let urlPath = this.apiUrl +'/GetUserProject';
    // Get the current user from AuthService
    const user = this.authService.getCurrentUser();
    const userGuid = user?.userGuid; // Adjust based on your user object structure

    if (!userGuid) {
      throw new Error('User GUID not found. User must be logged in.');
    }

    // Add userId as a query parameter
    const params = new HttpParams().set('userGuid', userGuid.toString());
    return this.http.get<Project[]>(urlPath, { params });
  }



  getProject(id: number): Observable<Project> {
    return this.http.get<Project>(`${this.apiUrl}/${id}`);
  }

  addProject(project: Project): Observable<Project> {
    const user = this.authService.getCurrentUser();
    if (!user || !user.userGuid) {
      throw new Error('User GUID not found. User must be logged in.');
    }

    const userGuid = user.userGuid;

    const newProject: ProjectDTO = {
       priority: project.priority,
         title: project.title,
         projectDescription: project.projectDescription,
        //  totalProjectPrice: project.totalProjectPrice;
        //  currentProjectPrice: project.currentProjectPrice;
        //  projectBids:project.Bed;
        //  contractors: ProjectContractor[];
        //  equipment: ProjectEquipment[];
        //  overhead: ProjectOverhead[];
        //  materials: ProjectMaterial[];
        //  fees: ProjectFee[];
        //  plans: ProjectPlan[];
        //  projectImage: ProjectImage[];
        //  projectDrawing: ProjectDrawing[];
        //  projectTasks: Array<ProjectTask>; 
         userGuid: userGuid
       }

    // No need to delete project.id here since you're not using `project` anymore
    return this.http.post<Project>(this.apiUrl, newProject);
  }
  updateProject(project: Project): Observable<void> {
 
    return this.http.put<void>(`${this.apiUrl}/${project.id}`, project,
    {
      headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      }
    );
    }

  deleteProject(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
  // updateProject(project: Project): Observable<void> {
  //   return this.http.put<void>(`${this.apiUrl}/${project.id}`, project);

    
  // }
  // Other CRUD methods
}
